module.exports = __webpack_public_path__ + "media/img/home/img_ph-8b6bf24bfbe4db8f0075e47f40edf0bf.png";